<script setup>
import {useRouter, useRoute} from 'vue-router';
import {computed} from "vue";

// Props
const props = defineProps({
  hideTitle: {
    type: Boolean,
    default: false
  },
  club: {
    type: Object,
    default: null
  },
  clubId: {
    type: String,
    required: false
  }
});

// Router and Route
const router = useRouter();
const route = useRoute();

// Methods
const navigateToClubDetail = (clubId) => {
  if (route.name !== 'ClubDetail') {
    router.push({name: 'ClubDetail', params: {clubId}});
  }
};

const {item, getItem, itemPending : loading} = useCrudApi('api/v2/clubs');

const currentItem = computed(() => props.club || item.value);

if (props.clubId && !currentItem.value.id) {
  getItem(props.clubId);
}

</script>

<template>

  <!-- Club name only — the address was removed (often long and unnecessary).
       hideTitle (e.g. the club's own stats page, where the name is already in the
       header) leaves nothing to show, so the chip isn't rendered. -->
  <v-chip
      class="text-wrap club-chip"
      style="height: auto"
      @click="() => navigateToClubDetail(currentItem.slug)"
      v-if="(currentItem || loading) && !hideTitle"
  >
    <v-skeleton-loader height="25" v-if="loading"/>
    <strong v-else>{{ currentItem.name }}</strong>
  </v-chip>
</template>

<style scoped lang="scss">
/* status-style chip (mockups/redesign .chip) — hairline, 11px/600, pill */
.club-chip {
  font-size: 11px;
  font-weight: 600;
  border-radius: 999px;
  background: rgb(var(--v-theme-light));
  border: 1px solid rgb(var(--v-theme-borderLight));
  color: rgb(var(--v-theme-charcoal));
  padding: 4px 10px;

  :deep(.v-chip__underlay) {
    opacity: 0;
  }
}
</style>
